import { render } from "./CategoryOneDuplicateDialog.vue?vue&type=template&id=19c99a1a&scoped=true"
import script from "./CategoryOneDuplicateDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryOneDuplicateDialog.vue?vue&type=script&lang=ts"

import "./CategoryOneDuplicateDialog.vue?vue&type=style&index=0&id=19c99a1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19c99a1a"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
